"use client";

import { useTranslations } from "use-intl";

import { WhatsAppIcon } from "@/components/icons/whatsapp-icon";
import { Button } from "@/components/ui/button";

interface PhoneOtpPrimaryActionProps {
  code: string;
  hasSentCode: boolean;
  sending: boolean;
  show: boolean;
  verifying: boolean;
  onSendCode: () => Promise<void>;
  onVerifyCode: () => Promise<void>;
}

/** Renders the default send or verify action for standalone OTP forms. */
export function PhoneOtpPrimaryAction(props: PhoneOtpPrimaryActionProps) {
  const t = useTranslations("globals.auth");

  if (!props.show) return null;
  if (props.hasSentCode) {
    return (
      <Button
        type="button"
        className="w-full"
        disabled={props.verifying || props.code.length !== 6}
        onClick={props.onVerifyCode}
      >
        {props.verifying ? t("submitting") : t("verifyPhone")}
      </Button>
    );
  }

  return (
    <Button
      type="button"
      variant="outline"
      size="lg"
      className="w-full border-[#25D366] bg-transparent text-[#25D366] hover:bg-[#25D366]/10 hover:text-[#25D366]"
      disabled={props.sending}
      onClick={props.onSendCode}
    >
      <WhatsAppIcon className="size-5" />
      {props.sending ? t("submitting") : t("sendPhoneCode")}
    </Button>
  );
}
